!(function (e) {
    var t = {};
    function n(i) {
        if (t[i]) return t[i].exports;
        var r = (t[i] = { i: i, l: !1, exports: {} });
        return e[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
    }
    (n.m = e),
        (n.c = t),
        (n.d = function (e, t, i) {
            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
        }),
        (n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (n.t = function (e, t) {
            if ((1 & t && (e = n(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if ((n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var r in e)
                    n.d(
                        i,
                        r,
                        function (t) {
                            return e[t];
                        }.bind(null, r)
                    );
            return i;
        }),
        (n.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                        return e.default;
                    }
                    : function () {
                        return e;
                    };
            return n.d(t, "a", t), t;
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.p = ""),
        n((n.s = 1));
})([
    function (e, t) {
        function n(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                t &&
                    (i = i.filter(function (t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })),
                    n.push.apply(n, i);
            }
            return n;
        }
        function i(e) {
            for (var t = 1; t < arguments.length; t++) {
                var i = null != arguments[t] ? arguments[t] : {};
                t % 2
                    ? n(Object(i), !0).forEach(function (t) {
                        r(e, t, i[t]);
                    })
                    : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
                        : n(Object(i)).forEach(function (t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                        });
            }
            return e;
        }
        function r(e, t, n) {
            return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n), e;
        }
        /* Removed: leftover product tracking code (product impressions, product link clicks and add to bag).
           It called functions c, o and a, which do not exist in this file, so it only produced errors. */
    },
    function (e, t, n) {
        "use strict";
        n.r(t);
        n(0);
        var i = { mobile: 768, tabletVertical: 980, tablet: 1200, laptop: 1480, large: 1680 };
        function r(e) {
            return (t = i[e]), window.matchMedia("(min-width: ".concat(t, "px)")).matches;
            var t;
        }
        function a(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var o = "[data-meganav-links-heading]",
            c = "[data-meganav-links]",
            u = (function () {
                function e(t, n) {
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = t),
                        (this.item = n),
                        (this.heading = t.querySelector(o)),
                        (this.links = t.querySelector(c)),
                        (this.toggleMenuItems = this.toggleMenuItems.bind(this)),
                        this.initEventListeners();
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "initEventListeners",
                            value: function () {
                                this.heading.addEventListener("click", this.toggleMenuItems);
                            },
                        },
                        {
                            key: "menuItemsOpen",
                            get: function () {
                                return "false" == this.links.getAttribute("aria-hidden");
                            },
                        },
                        {
                            key: "toggleMenuItems",
                            value: function () {
                                this.menuItemsOpen ? this.closeMenuItems() : this.openMenuItems();
                            },
                        },
                        {
                            key: "openMenuItems",
                            value: function () {
                                this.item.closeAllMenus(), this.links.setAttribute("aria-hidden", !1);
                            },
                        },
                        {
                            key: "closeMenuItems",
                            value: function () {
                                this.links.setAttribute("aria-hidden", !0);
                            },
                        },
                    ]) && a(t.prototype, n),
                    i && a(t, i),
                    e
                );
            })();
        function s(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var l = "[data-meganav-item-content]",
            h = "[data-meganav-menu]",
            d = (function () {
                function e(t, n) {
                    var i = this;
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = t),
                        (this.meganav = n),
                        (this.content = t.querySelector(l)),
                        (this.menus = Array.from(t.querySelectorAll(h)).map(function (e) {
                            return new u(e, i);
                        })),
                        this.attachEvents();
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "attachEvents",
                            value: function () {
                                var e = this;
                                this.element.addEventListener("mouseover", function (t) {
                                    return e.openContent(t);
                                }),
                                    this.element.addEventListener("mouseout", function (t) {
                                        return e.closeContent(t);
                                    });
                            },
                        },
                        {
                            key: "openContent",
                            value: function () {
                                this.content.setAttribute("aria-hidden", !1);
                            },
                        },
                        {
                            key: "closeContent",
                            value: function () {
                                this.content.setAttribute("aria-hidden", !0);
                            },
                        },
                    ]) && s(t.prototype, n),
                    i && s(t, i),
                    e
                );
            })();
        function f(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var v = "[data-meganav-item-back]",
            m = "[data-meganav-submenu-trigger]",
            y = (function () {
                function e(t) {
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = t),
                        (this.trigger = t.parentNode.querySelector(m)),
                        (this.back = t.querySelector(v)),
                        this.attachEvents();
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "isOpen",
                            get: function () {
                                return "false" == this.element.getAttribute("aria-hidden");
                            },
                        },
                        {
                            key: "attachEvents",
                            value: function () {
                                var e = this;
                                this.trigger.addEventListener("click", function (t) {
                                    e.open(), t.preventDefault();
                                }),
                                    this.back &&
                                    this.back.addEventListener("click", function (t) {
                                        return e.close();
                                    });
                            },
                        },
                        {
                            key: "open",
                            value: function () {
                                this.element.setAttribute("aria-hidden", !1);
                            },
                        },
                        {
                            key: "close",
                            value: function () {
                                this.element.setAttribute("aria-hidden", !0);
                            },
                        },
                    ]) && f(t.prototype, n),
                    i && f(t, i),
                    e
                );
            })();
        function g(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var b = "[data-meganav-links-heading]",
            p = "[data-meganav-links]",
            k = "[data-meganav-submenu]",
            w = (function () {
                function e(t) {
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = t),
                        (this.heading = t.querySelector(b)),
                        (this.links = t.querySelector(p)),
                        this.initSubmenu(),
                        this.attachEvents();
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "isOpen",
                            get: function () {
                                return "false" == this.links.getAttribute("aria-hidden");
                            },
                        },
                        {
                            key: "attachEvents",
                            value: function () {
                                var e = this;
                                this.heading.addEventListener("click", function (t) {
                                    t.preventDefault(), e.open();
                                });
                            },
                        },
                        {
                            key: "initSubmenu",
                            value: function () {
                                var e = this.element.querySelector(k);
                                e && (this.submenu = new y(e));
                            },
                        },
                        {
                            key: "open",
                            value: function () {
                                this.links.setAttribute("aria-hidden", !1), this.element.dispatchEvent(new CustomEvent("mobile-menu.menu.opened", { bubbles: !0 }));
                            },
                        },
                        {
                            key: "close",
                            value: function () {
                                this.links.setAttribute("aria-hidden", !0);
                            },
                        },
                    ]) && g(t.prototype, n),
                    i && g(t, i),
                    e
                );
            })();
        function S(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var E = "mobile-menu--submenu-open",
            L = "mobile-background--set",
            O = "[data-meganav-item-content]",
            x = "[data-meganav-item-back]",
            A = "[data-meganav-menus]",
            C = "[data-meganav-item-title]",
            q = ".page-header",
            j = ".meganav",
            T = (function () {
                function e(t) {
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = t),
                        (this.title = t.querySelector(C)),
                        (this.content = t.querySelector(O)),
                        (this.back = t.querySelector(x)),
                        (this.header = document.querySelector(q)),
                        (this.nav = document.querySelector(j)),
                        (this.menus = Array.from(t.querySelector(A).children).map(function (e) {
                            return new w(e);
                        })),
                        this.attachEvents();
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "attachEvents",
                            value: function () {
                                var e = this;
                                this.title.addEventListener("click", function (t) {
                                    if (this.getAttribute('data-submenu-item') == "true") {
                                        t.preventDefault(), e.open();
                                    }
                                }),
                                    this.element.addEventListener("mobile-menu.menu.opened", function (t) {
                                        e.menus
                                            .filter(function (e) {
                                                return e.element !== t.target;
                                            })
                                            .forEach(function (e) {
                                                return e.close();
                                            });
                                    }),
                                    this.back &&
                                    this.back.addEventListener("click", function (t) {
                                        return e.close();
                                    });
                            },
                        },
                        {
                            key: "open",
                            value: function () {
                                document.body.classList.add(E, L), this.menus[0].open(), this.content.setAttribute("aria-hidden", !1), this.header.style.removeProperty("background");
                            },
                        },
                        {
                            key: "close",
                            value: function () {
                                document.body.classList.remove(E),
                                    this.content.setAttribute("aria-hidden", !0),
                                    this.menus.forEach(function (e) {
                                        return e.close();
                                    });
                                var e = this.nav.getAttribute("data-mobile-background-colour");
                                this.header.style.background = e;
                            },
                        },
                    ]) && S(t.prototype, n),
                    i && S(t, i),
                    e
                );
            })();
        function P(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var M = ".page-header",
            I = "[data-meganav-item]",
            D = "[data-search-trigger]",
            _ = "[data-meganav-trigger]",
            N = "[data-mobile-background-colour]",
            F = "[data-mobile-item-colour]",
            B = ".meganav-item__title",
            J = ".meganav-actions__icon",
            R = "data-meganav-item-title-colour",
            U = "meganav--desktop",
            z = "meganav--mobile",
            V = "mobile-menu--open",
            H = "mobile-background--set",
            W = "mobile-item-colour--set",
            G = (function () {
                function e(t) {
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = t.cloneNode(!0)),
                        (this.header = document.querySelector(M)),
                        (this.triggers = document.querySelectorAll(_)),
                        (this.searchTrigger = document.querySelector(D)),
                        (this.background = document.querySelector(N)),
                        (this.initialItemColour = document.querySelector(F)),
                        (this.itemLinks = this.element.querySelectorAll(B)),
                        (this.actionIcons = this.element.querySelectorAll(J)),
                        (this.items = Array.from(this.element.querySelectorAll(I)).map(function (e) {
                            return new T(e);
                        })),
                        this.insertMobileNav(),
                        this.attachEvents();
                    var n = this.element.getAttribute("data-mobile-background-colour"),
                        i = this.element.getAttribute("data-mobile-item-colour"),
                        r = this.element.getAttribute("data-mobile-action-colour");
                    n && document.body.classList.add(H),
                        i && document.body.classList.add(W),
                        (this.element.style.backgroundColor = n),
                        this.itemLinks.forEach(function (e) {
                            var t = e.getAttribute(R);
                            e.style.color = t || i;
                        }),
                        this.actionIcons.forEach(function (e) {
                            e.style.color = r;
                        });
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "isOpen",
                            get: function () {
                                return "false" == this.element.getAttribute("aria-hidden");
                            },
                        },
                        {
                            key: "insertMobileNav",
                            value: function () {
                                var e, t;
                                this.header.parentNode.insertBefore(this.element, this.header.nextSibling), (e = this.element.classList), (t = e).remove(U), t.add(z), this.element.setAttribute("aria-hidden", !0);
                            },
                        },
                        {
                            key: "attachEvents",
                            value: function () {
                                var e = this;
                                this.triggers.forEach(function (t) {
                                    return t.addEventListener("click", function (t) {
                                        return e.toggle();
                                    });
                                }),
                                    this.searchTrigger.addEventListener("click", function (t) {
                                        return e.close();
                                    });
                            },
                        },
                        {
                            key: "toggle",
                            value: function () {
                                this.isOpen ? this.close() : this.open();
                            },
                        },
                        {
                            key: "open",
                            value: function () {
                                document.body.classList.add(V), this.element.setAttribute("aria-hidden", !1);
                                var e = this.element.getAttribute("data-mobile-background-colour"),
                                    t = this.element.getAttribute("data-mobile-action-colour");
                                (this.header.style.background = e), (this.header.style.color = t);
                            },
                        },
                        {
                            key: "close",
                            value: function () {
                                document.body.classList.remove(V),
                                    this.items.forEach(function (e) {
                                        return e.close();
                                    }),
                                    this.element.setAttribute("aria-hidden", !0),
                                    this.header.style.removeProperty("background"),
                                    this.header.style.removeProperty("color");
                            },
                        },
                    ]) && P(t.prototype, n),
                    i && P(t, i),
                    e
                );
            })();
        function K(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var Q = "[data-meganav-item]",
            X = "[data-meganav]",
            Y = (function () {
                function e() {
                    var t = this;
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        (this.element = document.querySelector(X)),
                        (this.mobile = new G(this.element)),
                        (this.booted = !1),
                        (this.items = Array.from(this.element.querySelectorAll(Q)).map(function (e) {
                            return new d(e, t);
                        })),
                        this.setUp();
                }
                var t, n, i;
                return (
                    (t = e),
                    (n = [
                        {
                            key: "setUp",
                            value: function () {
                                var e,
                                    t,
                                    n,
                                    i,
                                    r = this;
                                window.resize =
                                    ((e = function () {
                                        return r.onWindowResize();
                                    }),
                                        (t = 100),
                                        function () {
                                            var r = this,
                                                a = arguments,
                                                o = function () {
                                                    (i = null), n || e.apply(r, a);
                                                },
                                                c = n && !i;
                                            clearTimeout(i), (i = setTimeout(o, t)), c && e.apply(r, a);
                                        });
                            },
                        },
                        {
                            key: "onWindowResize",
                            value: function () {
                                return this.booted && !r("tabletVertical") ? this.attachEvents() : !this.booted && r("tabletVertical") ? this.detachEvents() : void 0;
                            },
                        },
                    ]) && K(t.prototype, n),
                    i && K(t, i),
                    e
                );
            })();
        function Z(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var $ = "[data-search-trigger]",
            ee = "[data-search-container]",
            te = (function () {
                function e() {
                    !(function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e);
                }
                var t, n, i;
                return (
                    (t = e),
                    (i = [
                        {
                            key: "triggers",
                            get: function () {
                                return document.querySelectorAll($);
                            },
                        },
                        {
                            key: "container",
                            get: function () {
                                return document.querySelector(ee);
                            },
                        },
                        {
                            key: "close",
                            value: function () {
                                e.container.classList.remove("active");
                            },
                        },
                        {
                            key: "initialiseEventHandlers",
                            value: function () {
                                e.triggers.forEach(function (e) {
                                    e.addEventListener("click", function () {
                                        return document.dispatchEvent(new Event("searchOpened"));
                                    });
                                });
                            },
                        },
                    ]),
                    (n = null) && Z(t.prototype, n),
                    i && Z(t, i),
                    e
                );
            })();
        function ne(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        var ie = (function () {
            function e(t) {
                !(function (e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                })(this, e),
                    (this.container = t),
                    (this.lastState = null),
                    this.initialiseEventListeners();
            }
            var t, n, i;
            return (
                (t = e),
                (n = [
                    {
                        key: "toggle",
                        value: function () {
                            this.container.classList.toggle("active", this.active), this.active ? this.textarea.focus() : this.cancel(), this.resetButtons();
                        },
                    },
                    {
                        key: "checkbox",
                        get: function () {
                            return this.container.querySelector("[data-enable]");
                        },
                    },
                    {
                        key: "textarea",
                        get: function () {
                            return this.container.querySelector("[data-message-textarea]");
                        },
                    },
                    {
                        key: "title",
                        get: function () {
                            return this.container.querySelector("[data-title]");
                        },
                    },
                    {
                        key: "titleStrings",
                        get: function () {
                            return JSON.parse(this.title.dataset.strings);
                        },
                    },
                    {
                        key: "active",
                        get: function () {
                            return this.checkbox.checked;
                        },
                    },
                    {
                        key: "maxLength",
                        get: function () {
                            return this.textarea.getAttribute("maxlength");
                        },
                    },
                    {
                        key: "remainingCharacterCount",
                        get: function () {
                            return this.maxLength - this.textarea.value.length;
                        },
                    },
                    {
                        key: "remainingCharacterCountElement",
                        get: function () {
                            return this.container.querySelector("[data-remaining-characters]");
                        },
                    },
                    {
                        key: "message",
                        get: function () {
                            return this.textarea.value;
                        },
                    },
                    {
                        key: "buttons",
                        get: function () {
                            return { cancel: this.container.querySelector("[data-cancel]"), save: this.container.querySelector("[data-save]") };
                        },
                    },
                    {
                        key: "updateRemainingCharacterCount",
                        value: function () {
                            this.remainingCharacterCountElement.innerText = this.remainingCharacterCount;
                        },
                    },
                    {
                        key: "updateAttribute",
                        value: function (e) {
                            return (
                                this.restrictCharacterSet(),
                                e && (e = e.replace(/[^\x0A\x0D\x20-\x7E]/gm, "")),
                                fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, redirect: "follow", body: JSON.stringify({ attributes: { gift_note: e } }) })
                            );
                        },
                    },
                    {
                        key: "save",
                        value: function () {
                            var e = this;
                            if (this.message.length > this.maxLength) return !1;
                            (this.buttons.save.innerText = "Saving..."),
                                this.updateAttribute(this.message)
                                    .then(function () {
                                        return e.onSuccess();
                                    })
                                    .catch(function (t) {
                                        return e.onFailure(t);
                                    })
                                    .finally(function () {
                                        return e.resetButtons();
                                    });
                        },
                    },
                    {
                        key: "cancel",
                        value: function () {
                            var e = this;
                            (this.textarea.value = ""),
                                (this.checkbox.checked = !1),
                                (this.title.innerText = this.titleStrings.add),
                                this.updateAttribute("")
                                    .then(function () {
                                        return e.onCancel();
                                    })
                                    .catch(function (t) {
                                        return e.onFailure(t);
                                    })
                                    .finally(function () {
                                        return e.resetButtons();
                                    });
                        },
                    },
                    {
                        key: "onSuccess",
                        value: function () {
                            this.message ? (this.title.innerText = this.titleStrings.added) : (this.title.innerText = this.titleStrings.add), (this.lastState = "success");
                        },
                    },
                    {
                        key: "onCancel",
                        value: function () {
                            (this.title.innerText = this.titleStrings.add), (this.lastState = null);
                        },
                    },
                    {
                        key: "onFailure",
                        value: function (e) {
                            console.error(e), (this.title.innerText = this.titleStrings.add), (this.lastState = "error");
                        },
                    },
                    {
                        key: "resetButtons",
                        value: function () {
                            null === this.lastState || "error" === this.lastState ? (this.buttons.save.innerText = "Save") : (this.buttons.save.innerText = "Edit");
                        },
                    },
                    {
                        key: "restrictCharacterSet",
                        value: function () {
                            (this.textarea.value = this.textarea.value.replace(/[^\x0A\x0D\x20-\x7E]/gm, "")), this.updateRemainingCharacterCount();
                        },
                    },
                    {
                        key: "keyUpListener",
                        value: function () {
                            (this.lastState = null), this.resetButtons(), this.restrictCharacterSet();
                        },
                    },
                    {
                        key: "initialiseEventListeners",
                        value: function () {
                            var e = this;
                            this.checkbox.addEventListener("change", function () {
                                return e.toggle();
                            }),
                                this.textarea.addEventListener("keyup", function () {
                                    return e.keyUpListener();
                                }),
                                this.buttons.save.addEventListener("click", function (t) {
                                    t.preventDefault(), e.save();
                                }),
                                this.buttons.cancel.addEventListener("click", function (t) {
                                    t.preventDefault(), (e.checkbox.checked = !1), e.toggle();
                                });
                        },
                    },
                ]) && ne(t.prototype, n),
                i && ne(t, i),
                e
            );
        })();
        window.meganav = new Y();
        var re = document.querySelector("[data-gift-message]");
        re && new ie(re), te.initialiseEventHandlers();
    },
]);
